import {
  SW_SET_UPDATE_AVAIL, SW_SET_UPDATE_READY, SW_SET_IS_UPDATING, SW_SET_REGISTRATION,
} from './mutations.types'
import {
  SW_DO_UPDATE,
} from './actions.types'

const initialState = {
  updateAvail: false,
  updateReady: false,
  isUpdating: false,
  registration: {},
}

export const state = { ...initialState }

export const actions = {
  async [SW_DO_UPDATE] ({ dispatch, commit, rootState, state }, payload) {
    try {
      commit(SW_SET_UPDATE_AVAIL, false)
      commit(SW_SET_IS_UPDATING, true)
      if (state.registration || state.registration.waiting) {
        state.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      }
    } catch (e) {
      return false
      // throw await dispatch(_PROCESS_ERROR, e)
    }
  },

}

export const mutations = {
  [SW_SET_UPDATE_AVAIL] (state, data) {
    state.updateAvail = data
  },
  [SW_SET_UPDATE_READY] (state, data) {
    state.updateReady = data
  },
  [SW_SET_IS_UPDATING] (state, data) {
    state.isUpdating = data
  },
  [SW_SET_REGISTRATION] (state, data) {
    state.registration = data
  },

}
export const getters = {
  swUpdateAvail: state => state.updateAvail,
  swUpdateReady: state => state.updateReady,
  swIsUpdating: state => state.isUpdating,
  swRegistration: state => state.registration,
}

export default {
  state,
  actions,
  mutations,
  getters,
}
